module.exports = __webpack_public_path__ + "img/mac-icon3.95f2614.png";